<div
    class="agpr-socialSearchDetails"
>
    <div class="agpr-socialSearchDetails-header">
        <h3 class="agpr-socialSearchDetails-title">
            {{ 'Social.intelligence.theme.lhp.searchDetails' | localize }}
        </h3>
        <div class="agpr-socialSearchDetails-expandToggle">
            <agpr-button
                class="agpr-socialSearchDetails-expandToggleIcon"
                [style]="buttonTypes.icon"
                [icon]="searchDetailsExpanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                (click)="searchDetailsExpanded = !searchDetailsExpanded"
            ></agpr-button>
        </div>
    </div>
    <agpr-scroll-panel>
        <div [@containerState]="searchDetailsExpanded ? 'visible' : 'hidden'">
            <!-- media types -->
            <div
                *ngIf="activeSearch?.mediaTypes?.length"
                class="agpr-socialSearchDetails-group"
            >
                <div class="agpr-socialSearchDetails-title">
                    {{ 'Social.intelligence.theme.lhp.searchDetails.network' | localize }}
                </div>
                <span class="agpr-socialSearchDetails-content">
                    @for (mediaType of mediaTypes; track mediaType; let last = $last) {
                        {{ 'Social.network.' + mediaType | localize }}
                        @if (!last) {
                            {{', '}}
                        }
                    }
                </span>
            </div>
            <!-- keywords -->
            <div
                *ngIf="activeSearch?.keywords?.hasIncludeKeywords() || activeSearch?.keywords?.hasExcludeKeywords()"
                class="agpr-socialSearchDetails-group"
            >
                <div class="agpr-socialSearchDetails-title">
                    {{ 'Social.intelligence.theme.lhp.searchDetails.keywords' | localize }}
                </div>
                <div *ngIf="activeSearch.keywords.or?.length">
                    <div class="agpr-socialSearchDetails-content agpr-socialSearchDetails-content--highlight">
                        {{ 'Social.intelligence.theme.lhp.searchDetails.or' | localize }}
                    </div>
                    <span class="agpr-socialSearchDetails-content">{{activeSearch.keywords.or.join(', ')}}</span>
                </div>
                <div *ngIf="activeSearch.keywords.and?.length">
                    <div class="agpr-socialSearchDetails-content agpr-socialSearchDetails-content--highlight">
                        {{ 'Social.intelligence.theme.lhp.searchDetails.and' | localize }}
                    </div>
                    <span class="agpr-socialSearchDetails-content">{{activeSearch.keywords.and.join(', ')}}</span>
                </div>
                <div *ngIf="activeSearch.keywords.not?.length">
                    <div class="agpr-socialSearchDetails-content agpr-socialSearchDetails-content--highlight">
                        {{ 'Social.intelligence.theme.lhp.searchDetails.not' | localize }}
                    </div>
                    <span class="agpr-socialSearchDetails-content">{{activeSearch.keywords.not.join(', ')}}</span>
                </div>
            </div>
            <!-- handles -->
            <div
                *ngIf="activeSearch?.hasHandles()"
                class="agpr-socialSearchDetails-group"
            >
                <div class="agpr-socialSearchDetails-title">
                    {{ 'Social.intelligence.theme.lhp.searchDetails.handle/channel' | localize }}
                </div>
                <div *ngFor="let mediaTypeRequest of activeSearch.mediaTypeRequests">
                    <div *ngIf="mediaTypeRequest.handles?.length">
                        <span class="agpr-socialSearchDetails-content agpr-socialSearchDetails-content--highlight">
                            {{ 'Social.network.' + mediaTypeRequest.mediaType | localize }}
                        </span>
                        <span class="agpr-socialSearchDetails-content">
                            {{' - ' + mediaTypeRequest.handles.join(', ')}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </agpr-scroll-panel>
</div>
